/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
const hasLocalStorage = () => typeof window !== "undefined" && typeof window.localStorage !== "undefined";
const mapToObject = (map) => {
    const object = {};
    map.forEach(function (value, key) {
        object[key] = value;
    });
    return object;
};
export const removeFromStorage = (key) => {
    if (!hasLocalStorage())
        return false;
    window.localStorage.removeItem(key);
    return true;
};
export const saveToStorage = (key, data) => {
    if (!hasLocalStorage())
        return false;
    if (data instanceof Map) {
        data = mapToObject(data);
    }
    window.localStorage.setItem(key, JSON.stringify(data));
    return true;
};
export const loadFromStorage = (key, ctor) => {
    if (!hasLocalStorage())
        return null;
    const item = window.localStorage.getItem(key);
    if (item === null)
        return null;
    try {
        if (ctor && ctor.name === "Map") {
            const map = new Map(Object.entries(JSON.parse(item)));
            return map;
        }
        return JSON.parse(item);
    }
    catch (_a) {
        return null;
    }
};
//# sourceMappingURL=storage.js.map